import { PATHS } from '../navigation/paths';
import { STORAGE_KEYS, AUTH_AWAY_MAX_MS } from './constants';

/** Eski 10 dk mutlak oturum anahtarı — bir kez temizlenir */
const LEGACY_AUTH_SESSION_STARTED_AT = 'finly_auth_session_started_at';

/** Koruma altındaki portal yolları */
export const isProtectedPath = (pathname) =>
  pathname === PATHS.STUDENT ||
  pathname.startsWith(`${PATHS.STUDENT}/`) ||
  pathname === PATHS.INSTRUCTOR ||
  pathname.startsWith(`${PATHS.INSTRUCTOR}/`);

export const markHistorySessionRevoked = () => {
  window.sessionStorage.setItem(STORAGE_KEYS.HISTORY_SESSION_REVOKED, '1');
};

export const isHistorySessionRevoked = () =>
  window.sessionStorage.getItem(STORAGE_KEYS.HISTORY_SESSION_REVOKED) === '1';

export const clearHistorySessionRevoked = () => {
  window.sessionStorage.removeItem(STORAGE_KEYS.HISTORY_SESSION_REVOKED);
};

/** Login formu gönderildi — profil yüklenince portal jetonu verilecek */
export const markExplicitLoginIntent = () => {
  window.sessionStorage.setItem(STORAGE_KEYS.EXPLICIT_LOGIN_INTENT, '1');
  clearHistorySessionRevoked();
};

export const isExplicitLoginPending = () =>
  window.sessionStorage.getItem(STORAGE_KEYS.EXPLICIT_LOGIN_INTENT) === '1';

/** Portal erişim jetonu */
export const grantPortalAccess = (uid) => {
  if (!uid) return;
  window.sessionStorage.setItem(STORAGE_KEYS.PORTAL_SESSION_UID, String(uid));
  window.sessionStorage.removeItem(STORAGE_KEYS.EXPLICIT_LOGIN_INTENT);
  clearHistorySessionRevoked();
};

export const revokePortalAccess = () => {
  window.sessionStorage.removeItem(STORAGE_KEYS.PORTAL_SESSION_UID);
  window.sessionStorage.removeItem(STORAGE_KEYS.EXPLICIT_LOGIN_INTENT);
  markHistorySessionRevoked();
};

export const getPortalSessionUid = () =>
  window.sessionStorage.getItem(STORAGE_KEYS.PORTAL_SESSION_UID);

export const hasPortalAccessToken = () =>
  Boolean(getPortalSessionUid()) && !isHistorySessionRevoked();

export const isPortalAccessGranted = (uid) => {
  if (!uid || isHistorySessionRevoked()) return false;
  return getPortalSessionUid() === String(uid);
};

/**
 * Tarayıcı / sekme terk edildi — uzak kalma sayacı başlar.
 * Uygulama açık ve görünürken bu çağrılmaz; oturum süreyle bitmez.
 */
export const markAuthAway = () => {
  window.localStorage.setItem(STORAGE_KEYS.AUTH_AWAY_SINCE, String(Date.now()));
};

/** Uzak kalma sayacını ve eski mutlak oturum anahtarını temizler */
export const clearAuthAway = () => {
  window.localStorage.removeItem(STORAGE_KEYS.AUTH_AWAY_SINCE);
  window.localStorage.removeItem(LEGACY_AUTH_SESSION_STARTED_AT);
};

export const getAuthAwaySince = () => {
  const raw = window.localStorage.getItem(STORAGE_KEYS.AUTH_AWAY_SINCE);
  const since = Number(raw);
  return Number.isFinite(since) && since > 0 ? since : 0;
};

/**
 * Tarayıcıdan ayrılıp AUTH_AWAY_MAX_MS içinde dönülmedi mi?
 * Uzak kalma işareti yoksa (kullanımdayken) süresi dolmamış sayılır.
 */
export const isAuthAwayExpired = (maxMs = AUTH_AWAY_MAX_MS, now = Date.now()) => {
  const since = getAuthAwaySince();
  if (!since) return false;
  return now - since >= maxMs;
};
